export var Gender;
(function (Gender) {
    Gender["M"] = "m";
    Gender["F"] = "f";
})(Gender || (Gender = {}));
(function (Gender) {
    function getSalutation(t, value) {
        switch (value) {
            case Gender.M:
                return t('common:gender.m');
            case Gender.F:
                return t('common:gender.f');
        }
        // Unknown value, null or undefined
        return '';
    }
    Gender.getSalutation = getSalutation;
    function createOptions(t) {
        return [
            {
                label: t('common:gender.f'),
                value: Gender.F,
            },
            {
                label: t('common:gender.m'),
                value: Gender.M,
            },
        ];
    }
    Gender.createOptions = createOptions;
})(Gender || (Gender = {}));
// Currently not in use, we just get a title string
export var TitlePre;
(function (TitlePre) {
    TitlePre["DI"] = "DI";
    TitlePre["DI_FH"] = "DI (FH)";
    TitlePre["DKFM"] = "Dkfm.";
    TitlePre["DR"] = "Dr.";
    TitlePre["ING"] = "Ing.";
    TitlePre["MAG"] = "Mag.";
    TitlePre["MAG_FH"] = "Mag. (FH)";
    TitlePre["DDR"] = "DDr.";
    TitlePre["DI_FH_DR"] = "DI (FH) Dr.";
    TitlePre["DI_DR"] = "DI Dr.";
    TitlePre["DI_MAG"] = "DI Mag.";
    TitlePre["MAG_FH_DR"] = "Mag. (FH) Dr.";
    TitlePre["MAG_DR"] = "Mag. Dr.";
    TitlePre["MMAG"] = "MMag.";
    TitlePre["MAG_FH_DI_FH"] = "Mag. (FH) DI (FH)";
    TitlePre["MMAG_FH"] = "MMag. (FH)";
})(TitlePre || (TitlePre = {}));
(function (TitlePre) {
    function createOptions(_t) {
        return [
            TitlePre.DI,
            TitlePre.DI_FH,
            TitlePre.DKFM,
            TitlePre.DR,
            TitlePre.ING,
            TitlePre.MAG,
            TitlePre.MAG_FH,
            TitlePre.DDR,
            TitlePre.DI_FH_DR,
            TitlePre.DI_DR,
            TitlePre.DI_MAG,
            TitlePre.MAG_FH_DR,
            TitlePre.MAG_DR,
            TitlePre.MMAG,
            TitlePre.MAG_FH_DI_FH,
            TitlePre.MMAG_FH,
        ].map((value) => ({
            label: value,
            value,
        }));
    }
    TitlePre.createOptions = createOptions;
})(TitlePre || (TitlePre = {}));
export var TitlePost;
(function (TitlePost) {
    TitlePost["BA"] = "BA";
    TitlePost["BAKK"] = "Bakk.";
    TitlePost["BSC"] = "BSc";
    TitlePost["LLM"] = "LL.M";
    TitlePost["MA"] = "MA";
    TitlePost["MAS"] = "MAS";
    TitlePost["MBA"] = "MBA";
    TitlePost["MSC"] = "MSc";
    TitlePost["PHD"] = "PhD";
    TitlePost["BA_MA"] = "BA MA";
    TitlePost["BA_MSC"] = "BA MSc";
    TitlePost["BSC_MA"] = "BSc MA";
    TitlePost["BSC_MSC"] = "BSc MSc";
    TitlePost["MA_PHD"] = "MA PhD";
    TitlePost["MAS_PHD"] = "MAS PhD";
    TitlePost["MBA_PHD"] = "MBA PhD";
    TitlePost["MSC_MA"] = "MSc MA";
    TitlePost["MSC_PHD"] = "MSc PhD";
})(TitlePost || (TitlePost = {}));
(function (TitlePost) {
    function createOptions(_t) {
        return [
            TitlePost.BA,
            TitlePost.BAKK,
            TitlePost.BSC,
            TitlePost.LLM,
            TitlePost.MA,
            TitlePost.MAS,
            TitlePost.MBA,
            TitlePost.MSC,
            TitlePost.PHD,
            TitlePost.BA_MA,
            TitlePost.BA_MSC,
            TitlePost.BSC_MA,
            TitlePost.BSC_MSC,
            TitlePost.MA_PHD,
            TitlePost.MAS_PHD,
            TitlePost.MBA_PHD,
            TitlePost.MSC_MA,
            TitlePost.MSC_PHD,
        ].map((value) => ({
            label: value,
            value,
        }));
    }
    TitlePost.createOptions = createOptions;
})(TitlePost || (TitlePost = {}));
export var ReturnCallTimeFrame;
(function (ReturnCallTimeFrame) {
    ReturnCallTimeFrame["A"] = "9:00\u00A0-\u00A010:00";
    ReturnCallTimeFrame["B"] = "11:00\u00A0-\u00A012:00";
    ReturnCallTimeFrame["C"] = "13:00\u00A0-\u00A014:00";
    ReturnCallTimeFrame["D"] = "14:00\u00A0-\u00A015:00";
    ReturnCallTimeFrame["E"] = "15:00\u00A0-\u00A016:00";
    ReturnCallTimeFrame["F"] = "16:00\u00A0-\u00A017:00";
})(ReturnCallTimeFrame || (ReturnCallTimeFrame = {}));
(function (ReturnCallTimeFrame) {
    function createOptions(_t) {
        return [
            ReturnCallTimeFrame.A,
            ReturnCallTimeFrame.B,
            ReturnCallTimeFrame.C,
            ReturnCallTimeFrame.D,
            ReturnCallTimeFrame.E,
            ReturnCallTimeFrame.F,
        ].map((value) => ({
            label: value,
            value,
        }));
    }
    ReturnCallTimeFrame.createOptions = createOptions;
})(ReturnCallTimeFrame || (ReturnCallTimeFrame = {}));
